var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-list-content"},[_vm._t("tag"),_c('div',{staticClass:"list-item"},[_vm._t("default")],2),_vm._t("text-tag")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }